module.exports = __webpack_public_path__ + "img/photo-18.4e504faa.jpg";